import cn from 'classnames';
import React from 'react';
import { t } from '../../../utils/i18n';
import { Loader } from '../../Loader';
import { DH } from '../../../utils/DataHook';
import s from '../styles.scss';
import pageStyles from '../../Page/styles.scss';

export const AppLoader: React.FC = () => (
  <section data-hook={DH.AppLoader} className={s.loaderContainer}>
    <Loader />
  </section>
);
AppLoader.displayName = 'AppLoader';

export const SomethingWentWrong: React.FC = () => (
  <section data-hook={DH.Container} className={cn(s.errorContainer, pageStyles.root)}>
    <div tabIndex={0} role="heading">
      {t('app.error-screen.title')}
    </div>
    <div>{t('app.error-screen.subtitle')}</div>
  </section>
);
SomethingWentWrong.displayName = 'SomethingWentWrong';
